import { Grid, useMediaQuery } from '@mui/material';
import React from 'react';
import { Outlet } from 'react-router-dom';
import { variants } from '../variants/variants';
import { useTheme } from '@emotion/react';

const Announcements = () => {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('xs'));
  const isSm = useMediaQuery(theme.breakpoints.down('sm'));
  const isMd = useMediaQuery(theme.breakpoints.down('md'));
  const isLg = useMediaQuery(theme.breakpoints.down('lg'));
  const isXl = useMediaQuery(theme.breakpoints.up('xl'));
  return (
    <Grid
      container
      sx={{
        backgroundColor: isSm ? '' : '#EEF5FF',
        padding: isSm ? 0 : 1,
        border: isSm ? 0 : 1,
        height: '100%',
        // height: 'calc(100vh - 80px)',
        overflow: 'hidden',
        borderRadius: isSm ? 0 : variants.boxRadius.NAVBAR,
        borderColor: 'divider',
      }}
    >
      <Outlet />
    </Grid>
  );
};

export default Announcements;
